import { DataService } from 'src/app/features/dfte-grid-view/config/data.service';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';  // <-- Make sure to import `of` here
import { DconConfigAPI } from '../features/dfte-grid-view/config/config'; 


@Injectable({
  providedIn: 'root',
})
export class AdminService {
  private nodeBaseUrl =DconConfigAPI.NODE_URL; ;
   token = localStorage.getItem ('authToken');
    parsedToken=JSON.parse(this.token)
  
   // Replace with your real API URL
   // Dummy data (used until the real API is ready)

  constructor(private http: HttpClient) {}

  /**
   * Get users from the server. If the API isn't ready, fetch from the dummy data file.
   * @returns Observable<any[]> List of users
   */
  getUsers(): Observable<any[]> {
  
     // Create headers and add the Authorization header
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${this.parsedToken}`
    });
   const getApi = `${this.nodeBaseUrl}${DconConfigAPI.URL_PROPS.GET_USERS_ADMIN_DASHBOARD}`;
    // Send the HTTP request with the headers
    return this.http.get<any[]>(getApi, { headers });
  }
  addUserAdmin(user: any): Observable<any> {
  
const addApi=`${this.nodeBaseUrl}${DconConfigAPI.URL_PROPS.ADD_USER_ADMIN}`
const headers = new HttpHeaders({
  'Authorization': `Bearer ${this.parsedToken}`
});
   

    return this.http.post<any>(addApi, user,{headers});
   
  }
  updateUserById(user: any): Observable<any> {
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${this.parsedToken}`
    });
  
    const updateUserApi = `${this.nodeBaseUrl}${DconConfigAPI.URL_PROPS.UPDATE_ADMIN_USER}`;
  
    // Use PUT request for update (assuming the backend expects a PUT request)
    return this.http.put<any>(updateUserApi, user, { headers });
  }
resetPasswordByUsername(user):Observable<any>{
  const headers = new HttpHeaders({
    'Authorization': `Bearer ${this.parsedToken}`
  });
const resetpasswordApi=`${this.nodeBaseUrl}${DconConfigAPI.URL_PROPS.RESET_ADMIN_PASSWORD}`
return this.http.post<any>(resetpasswordApi,user,{headers})
}  
  
}
